import {parseInt} from "lodash";
import {useEffect, useState} from "react";
import StopAudioIcon from "../../../ui/svg/audio/stop-audio";
import PlayAudioIcon from "../../../ui/svg/audio/play-audio";
import {getSasUrl} from "./data-service";
import {AudioBase64StyleEnum, IAudioBase64Wrapper} from "./interfaces";
import PlayAudioTriangleIcon from "../../../ui/svg/audio/play-audio-trian";


interface IAudioBase64Props {
    elId: string,
    presetGuid: string,
    buttonStyle?: AudioBase64StyleEnum,
    buttonColor?: string,
    buttonBgColor?: string,
    showDebugInfo?: boolean
}

/**
 * the entry point
 */
const AudioBase64 = (props?: IAudioBase64Props) => {
    const buttonColor = props?.buttonColor ?? "#000000";
    const buttonBgColor = props?.buttonBgColor ?? "#ffffff";
    const buttonStyle = props?.buttonStyle ?? AudioBase64StyleEnum.DefaultStyle;

    const [isPlayed, setIsPlayed] = useState<boolean>(false);
    const [isFirstTimeSelected, setIsFirstTimeSelected] = useState<boolean>(false);
    const [perfTime, setPerfTime] = useState<number>(0);
    const [serverTime, setServerTime] = useState<string>("");
    const [player, setPlayer] = useState<any>(null);
    //var  player: any = null;

    useEffect(() => {
        (async () => {


        })()

    }, []);

    useEffect(() => {
            var playerHTML: any = document.getElementById('pb64_' + props?.elId);
            playerHTML.addEventListener("ended", function () {
                console.log("ended");
                setIsPlayed(false);
            });

            playerHTML.addEventListener("pause", function () {
                console.log("pause");
                setIsPlayed(false);
            });
            setPlayer(playerHTML);
        },
        // VLAD TODO
        // eslint-disable-next-line
        []);
    const stopAllMusicOnPage = () => {
        const allAudio = document.getElementsByTagName('audio');
        // Loop through each audio element and pause it
        for (let i = 0; i < allAudio.length; i++) {
            // Check if the audio is playing
            if (!allAudio[i].paused) {
                allAudio[i].pause();
                allAudio[i].currentTime = 0; // Optionally reset the playback position to the start
            }
        }

    };
    const loadBase64Str = async () => {

        if (props?.presetGuid) {
            var startTime = performance.now()


            const response = await getSasUrl(props?.presetGuid);
            if (!response || response.statusCode !== 200) {
                //setError(response.data as unknown as ModelServerErrors);
                return;
            }
            const ab64Wrap = response.data as IAudioBase64Wrapper;
            console.log('sasUrl: ', ab64Wrap);
            player.src = `data:audio/mp3;base64,${ab64Wrap.base64Str}`;
            setIsFirstTimeSelected(true);
            var endTime = performance.now();
            setPerfTime(endTime - startTime);
            setServerTime(ab64Wrap.pResult.resultEX);
        }
    };
    const playToggle = () => {
        if (!isFirstTimeSelected)
            loadBase64Str();
        if (player?.paused)
            play();
        else
            stop();
    };
    const play = () => {
        stopAllMusicOnPage();
        if (player?.play) {
            setIsPlayed(true);
            player?.play();
        }
    };
    const pause = () => {
        player?.pause();
        setIsPlayed(false);
    };
    const stop = () => {
        player?.pause();
        if (player) {
            player.currentTime = 0;
        }
        setIsPlayed(false);
    }
    // player.onloadedmetadata = function() {
    //     console.log('onloadedmetadata');
    // };


    return (
        <div className="">

            {props?.showDebugInfo && <div>AudioBase64 {props?.presetGuid} /
                {perfTime !== 0 && <span>load time: {(perfTime / 1000).toFixed(2)} sec | {serverTime}</span>}
            </div>}

            <div>
                {/*DefaultStyle*/}
                {
                    buttonStyle === AudioBase64StyleEnum.DefaultStyle &&
                    <span
                        className={`w-btn ${isFirstTimeSelected ? "bg-blue-150" : "bg-gray-200"} rounded-full w-32 p-3 md:p-4 lg:p-2 mt-0 md:mt-0 lg:mt-0 md:text-lg text-gray-700`}
                        onClick={evt => {
                            playToggle();
                        }} >
                        <span className="flex flex-row items-center justify-center">
                            {
                                (!isPlayed) &&
                                <PlayAudioIcon width="20" height="20" color="#ffffff" bgColor="#000000"/>
                            }
                            {
                                (isPlayed) &&
                                <StopAudioIcon width="20" height="20" color="#ffffff" bgColor="#000000"/>
                            }
                            <span className="pl-2">{!isPlayed ? 'Play' : 'Stop'}</span>
                        </span>
                    </span>
                }
                {/*ChainStyle*/}
                {
                    buttonStyle === AudioBase64StyleEnum.ChainStyle &&
                    <span
                        className={`w-btn ${isFirstTimeSelected ? "bg-white" : "bg-white"} border border-gray-700 rounded-full w-32 p-3 md:p-4 lg:p-2 mt-0 md:mt-0 lg:mt-0 md:text-lg text-gray-700`}
                        onClick={evt => {
                            playToggle();
                        }} >
                        <span className="flex flex-row items-center justify-center">
                            <span className="pr-2">{!isPlayed ? 'Play' : 'Stop'}</span>
                            {
                                (!isPlayed) &&
                                <PlayAudioTriangleIcon width="15" color="#000000" />
                            }
                            {
                                (isPlayed) &&
                                <StopAudioIcon width="20" height="20" color="#ffffff" bgColor="#000000"/>
                            }
                        </span>
                    </span>
                }
                {/*IconStyle*/}
                {
                    buttonStyle === AudioBase64StyleEnum.IconStyle &&

                        <span className="flex flex-row items-center justify-center"
                              onClick={evt => {
                                  playToggle();
                              }}>
                            {
                                (!isPlayed) &&
                                <PlayAudioIcon width="30" height="30" color={buttonColor} bgColor={buttonBgColor}/>
                            }
                            {
                                (isPlayed) &&
                                <StopAudioIcon width="30" height="30" color={buttonColor} bgColor={buttonBgColor}/>
                            }
                        </span>
                }
            </div>
        </div>
    )
};

export default AudioBase64;
